import React from 'react';
import {Modal, Button} from 'antd';
import {ExclamationCircleOutlined} from "@ant-design/icons";


export default function Warning(props) {
    const {open, title, onClose} = props


    return (

        <Modal visible={open}
               footer={null}
               closable={false}
               width={400}
        >
            <div className={"dialog"}>


                <div className={"delete-dialog-body column center"}>
                    <div className={"icon"}>
                        <ExclamationCircleOutlined/>
                    </div>
                    <div className={"subtitle"}>{title}</div>


                </div>
                <div className={"delete-dialog-footer row center"}>

                    <Button
                        onClick={onClose}
                        type="primary" style={{backgroundColor:"#377EF3"}}>OK</Button>
                </div>
            </div>
        </Modal>
    );
};
